import styled from 'styled-components'

export const MaxWidthWrapper = styled.div`
	max-width: 1680px;
	//if there is any requirement for background uncomment line 7
	/* background-image: url({iimBackground}); */
	background-repeat: no-repeat;
	background-position: center;
	margin-top: -19px;
`
export const LandingWrapper = styled.div`
	display: flex;
	flex-flow: column;
	align-items: center;
	justify-content: space-evenly;
	gap: 15px;
	margin-top: var(--mg-sm);
	min-height: 90vh;
	max-height: 90vh;
`
export const LandingText = styled.h2`
	font-size: var(--fs-xxxl);
	font-weight: var(--fw-xl);
	text-transform: uppercase;
	background: var(--bg-color-text);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	margin: 0px;
`

export const ButtonWrapper = styled.div`
	min-width: var(--width-sm);
	/* margin: 15px !important; */
	z-index: 1;
	margin-bottom: 15px;
`

export const ZeeLogoWrapper = styled.img`
	height: var(--el-hg-md);
	margin-top: 35px;
`

export const BottomLogoWrapper = styled.img`
	height: 48vh;
	width: 103%;
	margin-top: 10vh;
`

export const BottomLogoWrapperDesktop = styled.img`
	width: 105%;
	margin-top: -190px;
`

export const StarGroup = styled.img``

export const PlayWinText = styled.p`
	margin: 0;
	color: var(--dimmer-yellow);
`

export const TenK = styled.h1`
	margin: 0;
	color: var(--brighter-yellow);
`

export const PoweredByText = styled.p`
	margin: 0;
	font-weight: 500;
	font-size: 12px;
	color: #ffffff;
`

export const PoweredByLogo = styled.img`
	height: 100px;
	margin-top: -10px;
`
export const PoweredByWrapper = styled.div`
	margin-top: 20px;
`

export const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 12px;
`

export const ButtonSubWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
`
